export class RegistroAfiliado {
    idUnico: number;
    id: number;
    idProducto: number;
    nroDocumento: string;
    nombres: string;
    apellidos: string;
    nroMovil: string;
    nroFijo: string;
    email: string;
    domicilio: string;
    idDepartamento: string;
    idCiudad: string;
    valorProducto: string;
    tipoNotificacion: string;
    accionNotificacion: string;
    aliado: string;
    idAplicacion: number;
    idAliado: number;
    idCanal: number;
    canal: string;
    notificarCambios: boolean;
}